import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from '@shared/shared.module';
import {ParticleService} from '@core/services/particle.service';
import {FirmDynamicComponentHelper} from './firm-dynamic-component-helper';
import {SubAccountsComponent} from './components/sub-accounts/sub-accounts.component';
import {AddSubAccountDialogComponent} from './components/add-sub-account-dialog/add-sub-account-dialog.component';
import {firmRoutes} from './firm.route';
import {AddUserDialogComponent} from './components/add-user-dialog/add-user-dialog.component';
import {FirmApiService} from './services/firm-service';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformToolFirmSandboxHandler} from '@features/firm/platform-tool-handler/platform-tool-firm-sandbox-handler';
import {SubAccountsHandler} from '@features/firm/platform-tool-handler/sub-accounts-handler';
import {SubAccountUsersHandler} from '@features/firm/platform-tool-handler/sub-account-users-handler';
import {FirmSubAccountUsersGridHostComponent} from '@features/firm/components/sub-account-users-grid-host/sub-account-users-grid-host.component';
import {EditPackagesDialogComponent} from '@features/firm/components/edit-packages-dialog/edit-packages-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(firmRoutes),
    SharedModule
  ],
  declarations: [
    SubAccountsComponent,
    AddSubAccountDialogComponent,
    AddUserDialogComponent,
    FirmSubAccountUsersGridHostComponent,
    EditPackagesDialogComponent
  ],
  exports: [],
  providers: [FirmApiService]
})
export class FirmModule {
  constructor(protected particleService: ParticleService, private commandService: CommandService, private platformToolFirmSandboxHandler: PlatformToolFirmSandboxHandler, private subAccountsHandler: SubAccountsHandler, private subAccountUsersHandler: SubAccountUsersHandler) {
    FirmDynamicComponentHelper.init();
    FirmDynamicComponentHelper.register('PlatformToolFirmSandboxHandler', platformToolFirmSandboxHandler);
    FirmDynamicComponentHelper.register('SubAccountsHandler', subAccountsHandler);
    FirmDynamicComponentHelper.register('SubAccountUsersHandler', subAccountUsersHandler);

    const sandboxCommand = new PlatformCommand('SandboxUserForAdminstratorCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/firm/sandbox-users', sandboxCommand);

    const subAccountsCommand = new PlatformCommand('SubAccountsToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/firm/sub-accounts', subAccountsCommand);

    const subAccountUsersCommand = new PlatformCommand('SubAccountUsersToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/firm/sub-accounts/:id', subAccountUsersCommand);
  }
}

